import { defineMessages } from 'react-intl';

const messages: {
	error: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	info: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	success: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	warning: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	error: {
		id: 'eoc.common.toast.error',
		defaultMessage: 'Error',
		description: 'The title for an error as a single word.',
	},
	warning: {
		id: 'eoc.common.toast.warning',
		defaultMessage: 'Warning',
		description: 'The title for a warning as a single word.',
	},
	success: {
		id: 'eoc.common.toast.success',
		defaultMessage: 'Success',
		description:
			'The text is shown as the title of a success toast notification when an operation completes successfully.',
	},
	info: {
		id: 'eoc.common.toast.info',
		defaultMessage: 'Information',
		description: 'The title for an information as a single word.',
	},
});

export default messages;
